import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { v4 as uuidV4 } from "uuid";

export const covertToDropDownArray = (inputArray) => {
  return inputArray.map((item) => ({
    value: `${item.name ? item.name : ""} - ${
      item.description ? item.description : ""
    }`,
    metadata: {
      name: item.name ? item.name : "",
      description: !item.description ? "" : item.description,
      type: item.type ? item.type : "",
    },
  }));
};

export const sortLicenceData = (data) => {
  return [...data].sort((a, b) => {
    if (a.stateCode < b.stateCode) return -1;
    if (a.stateCode > b.stateCode) return 1;
    return 0;
  });
};

export const filteredLicenceAndDsciciplinaryData = (data, filterId) => {
  const filteredData = data.filter((item) => item.displayId === filterId);
  return filteredData[0];
};

export const generateDisplayId = () => {
  return Math.random().toString(36).toUpperCase().slice(2, 18);
};

export const getFormattedDate = () => {
  const current = new Date();
  return current.toISOString().slice(0, -1);
};

export const formatDate = (date) => {
  const options = { year: "numeric", month: "long", day: "numeric" };
  if (!date) return "";
  const parsedDate = new Date(date);
  return isNaN(parsedDate.getTime())
    ? ""
    : parsedDate.toLocaleDateString("en-US", options);
};

export const convertToPercentage = (value) => {
  return Math.round(value * 100);
};

export const FetchRequestHandler = async (method, url, data) => {
  const authKey = localStorage.getItem("auth-key");

  const config = {
    headers: {
      Authorization: `Bearer ${authKey}`,
      "X-Request-Id": uuidV4(),
    },
  };

  try {
    const response = await axios({ method, url, data, ...config });
    return { success: true, data: response.data, status: response.status };
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/";
    }
    return {
      success: false,
      data: error.response?.data || null,
      message: error.message, // this will gives both network errors & api errors
      status: error.response?.status || 500,
    };
  }
};

export const isActiveForPracticeAndProviderAndAccessPoint = (status) => {
  const accessPointStatus =
    status.accessPointStatus.isActive === true &&
    status.accessPointStatus.isDisplayedOnSite === true;
  const practiceStatus =
    status.practiceStatus.isActive === true &&
    status.practiceStatus.isDisplayedOnSite === true;
  const providerStatus =
    status.providerStatus.isActive === true &&
    status.providerStatus.isDisplayedOnSite === true;
  return accessPointStatus && practiceStatus && providerStatus;
};

export const FetchRequestHandlerLoginTest = async (method, url, data) => {
  const authKey = localStorage.getItem("auth-key");

  const config = {
    headers: {
      // "X-DeviceFP": "d485dbc29097bda4b5bc5b8325f5af46f2b036be678",
      Authorization: `Bearer ${authKey}`,
      "Content-Type": "application/json",
      "X-Request-Id": uuidV4(),
    },
  };

  try {
    const response = await axios({ method, url, data, ...config });
    return { success: true, data: response.data, status: response.status };
  } catch (error) {
    return {
      success: false,
      data: error.response?.data || null,
      message: error.message, // this will gives both network errors & api errors
      status: error.response?.status || 500,
    };
  }
};

export const getApiErrorMessage = (status) => {
  switch (status) {
    case 400:
    case 422:
      return "Something went wrong. Please check and try again.";
    case 401:
    case 403:
      return "You are not authorized to perform this action.";
    case 404:
      return "The requested information could not be found.";
    case 408:
    case 504:
      return "The request took too long. Please try again later.";
    case 429:
      return "You’ve made too many requests. Please wait and try again.";
    case 500:
    case 502:
    case 503:
      return "Oops! We’re facing some technical issues. Please try again later.";
    default:
      return "Something went wrong. Please try again.";
  }
};

const statesData = [
  { id: 1, value: "AL", stateName: "Alabama" },
  { id: 2, value: "AK", stateName: "Alaska" },
  { id: 3, value: "AZ", stateName: "Arizona" },
  { id: 4, value: "AR", stateName: "Arkansas" },
  { id: 5, value: "CA", stateName: "California" },
  { id: 6, value: "CO", stateName: "Colorado" },
  { id: 7, value: "CT", stateName: "Connecticut" },
  { id: 8, value: "DE", stateName: "Delaware" },
  { id: 9, value: "FL", stateName: "Florida" },
  { id: 10, value: "GA", stateName: "Georgia" },
  { id: 11, value: "HI", stateName: "Hawaii" },
  { id: 12, value: "ID", stateName: "Idaho" },
  { id: 13, value: "IL", stateName: "Illinois" },
  { id: 14, value: "IN", stateName: "Indiana" },
  { id: 15, value: "IA", stateName: "Iowa" },
  { id: 16, value: "KS", stateName: "Kansas" },
  { id: 17, value: "KY", stateName: "Kentucky" },
  { id: 18, value: "LA", stateName: "Louisiana" },
  { id: 19, value: "ME", stateName: "Maine" },
  { id: 20, value: "MD", stateName: "Maryland" },
  { id: 21, value: "MA", stateName: "Massachusetts" },
  { id: 22, value: "MI", stateName: "Michigan" },
  { id: 23, value: "MN", stateName: "Minnesota" },
  { id: 24, value: "MS", stateName: "Mississippi" },
  { id: 25, value: "MO", stateName: "Missouri" },
  { id: 26, value: "MT", stateName: "Montana" },
  { id: 27, value: "NE", stateName: "Nebraska" },
  { id: 28, value: "NV", stateName: "Nevada" },
  { id: 29, value: "NH", stateName: "New Hampshire" },
  { id: 30, value: "NJ", stateName: "New Jersey" },
  { id: 31, value: "NM", stateName: "New Mexico" },
  { id: 32, value: "NY", stateName: "New York" },
  { id: 33, value: "NC", stateName: "North Carolina" },
  { id: 34, value: "ND", stateName: "North Dakota" },
  { id: 35, value: "OH", stateName: "Ohio" },
  { id: 36, value: "OK", stateName: "Oklahoma" },
  { id: 37, value: "OR", stateName: "Oregon" },
  { id: 38, value: "PA", stateName: "Pennsylvania" },
  { id: 39, value: "RI", stateName: "Rhode Island" },
  { id: 40, value: "SC", stateName: "South Carolina" },
  { id: 41, value: "SD", stateName: "South Dakota" },
  { id: 42, value: "TN", stateName: "Tennessee" },
  { id: 43, value: "TX", stateName: "Texas" },
  { id: 44, value: "UT", stateName: "Utah" },
  { id: 45, value: "VT", stateName: "Vermont" },
  { id: 46, value: "VA", stateName: "Virginia" },
  { id: 47, value: "WA", stateName: "Washington" },
  { id: 48, value: "WV", stateName: "West Virginia" },
  { id: 49, value: "WI", stateName: "Wisconsin" },
  { id: 50, value: "WY", stateName: "Wyoming" },
  { id: 51, value: "DC", stateName: "District of Columbia" },
];

export default statesData;

export const sortProviderLicensesByState = (data) => {
  if (!data || !data.providerLicenseItemResponseDTOs) {
    return data;
  }

  const sortedData = {
    ...data,
    providerLicenseItemResponseDTOs: [
      ...data.providerLicenseItemResponseDTOs,
    ].sort((a, b) => a.stateCode.localeCompare(b.stateCode)),
  };

  return sortedData;
};

export const PHONE_NUMBER_REGEX = "^\\d{10}$";

export const EMAIL_REGEX = "^\\w+([.-]?\\w+)*@\\w+([.-]?\\w+)*(.\\w{2,3})+$";

export const DATE_REGEX = "^(0[1-9]|1[0-2])/(0[1-9]|[12]\\d|3[01])/\\d{4}$";

export const MONTH_YEAR_REGEX = "^(0[1-9]|1[0-2])/\\d{4}$";

export const getIsTheValueNotMatchedWithRegex = ({
  pattern,
  value,
  required,
}) => {
  if (!required && (value === "") | (value === undefined)) {
    return false;
  }

  try {
    const regexp = new RegExp(pattern);
    if (value?.search(regexp) === -1) {
      return true;
    }
  } catch (e) {
    console.error(e);
    return true;
  }

  return false;
};

/**
 * Converts a date string from mm/dd/yyyy format to yyyy-mm-dd format.
 * @param {string} date - Date in mm/dd/yyyy format.
 * @returns {string} Date in yyyy-mm-dd format.
 */
export const convertMMDDYYYYToYYYYMMDD = (date) => {
  if (!date) {
    return date;
  }
  const [mm, dd, yyyy] = date.split("/");
  return `${yyyy}-${mm}-${dd}`;
};

/**
 * Converts a date string from yyyy-mm-dd format to mm/dd/yyyy format.
 * @param {string} date - Date in yyyy-mm-dd format.
 * @returns {string} Date in mm/dd/yyyy format.
 */
export const convertYYYYMMDDToMMDDYYYY = (date) => {
  if (!date) {
    return date;
  }
  const [yyyy, mm, dd] = date.split("-");
  return `${mm}/${dd}/${yyyy}`;
};

/**
 * Converts a date string from mm/yyyy format to yyyy-mm format.
 * @param {string} date - Date in mm/yyyy format.
 * @param {string} backendDate - Date in yyyy-mm-dd format.
 *
 * @returns {string} Date in yyyy-mm-dd format.
 */
export const convertMMYYYYToYYYYMMDDWithGivenDay = (date, backendDate) => {
  if (!date) {
    return date;
  }
  let dd = "01";
  if (backendDate) {
    dd = backendDate.split("-")[2]; // Extract the day from the backend date
  }
  const [mm, yyyy] = date.split("/");
  return `${yyyy}-${mm}-${dd}`;
};

/**
 * Converts a date string from yyyy-mm format to mm/yyyy format.
 * @param {string} date - Date in yyyy-mm-dd format.
 * @returns {string} Date in mm/yyyy format.
 */
export const convertYYYYMMDDToMMYYYY = (date) => {
  if (!date) {
    return date;
  }
  const [yyyy, mm, dd] = date.split("-");
  if (dd === "") {
    console.log(dd);
  }
  return `${mm}/${yyyy}`;
};

/**
 *
 * @param {string} value - 1232123456 any 10 digit phone number
 * @returns {string} - 123-123-4567 with North American Numbering Plan format
 */
export const convertTenDigitPhoneNumberToNANP = (value) => {
  if (!value) {
    return value;
  }

  if (value.length > 12) {
    value = value.slice(0, 12);
  }

  if (value.length > 6) {
    value = `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6)}`;
  } else if (value.length > 3) {
    value = `${value.slice(0, 3)}-${value.slice(3)}`;
  }

  return value;
};

export const normalizeTimeRegexMatch = (input) => {
  // Check if input is not a string
  if (typeof input !== "string") {
    return null;
  }

  // Remove all spaces and make uppercase
  const cleaned = input.replace(/\s+/g, "").toUpperCase();

  // Extract time and AM/PM
  const match = cleaned.match(/^(\d{1,2}):(\d{2})(AM|PM)$/);
  if (!match) {
    return null;
  }
  return match;
};

/**
 *
 * @param {string} input example 01:00 AM.
 * 01:00 AM -> 01:00 AM
 * 25:01 AM -> 1:01 PM
 * 01:0 0 A M -> 01:00 AM
 */

export const normalizeTime = (input) => {
  // Check if input is not a string
  if (typeof input !== "string") {
    return input;
  }

  const match = normalizeTimeRegexMatch(input);

  if (!match) {
    return input;
  }

  let [, hour, minute, period] = match;
  hour = parseInt(hour, 10);

  hour = hour % 24;

  // Convert 24h to 12h if needed
  if (hour === 0) {
    hour = 12;
  }

  if (hour > 12) {
    hour = hour % 12;
    period = "PM";
  }

  hour = hour.toString().padStart(2, "0");

  return `${hour}:${minute} ${period}`;
};

export const decodeJWTToken = (token) => {
  try {
    const decodedToken = jwtDecode(token);
    return decodedToken;
  } catch (err) {
    console.error({ err });
  }
};

/**
 *
 * @param {string} input example 2018-08-31 in format: YYYY-MM-DD.
 * 2018-08-31 -> 08/31/2018.
 * outputs in format: MM/DD/YYYY
 */

export const formatDateUnrelatedTimezone = (
  dateString,
  isnotvalidRequired = true
) => {
  if (!dateString && isnotvalidRequired) return "Valid date not found";
  try {
    const [year, month, day] = dateString.split("-");
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  } catch {
    if (isnotvalidRequired) {
      return "Valid date not found";
    }
  }
};
